import { useState, useEffect } from "react";
import axios from "axios";
import { local_backend } from '../config';

// Module-level singleton cache ✅
let fetchPromise = null; // prevent duplicate fetch calls

const useExpenses = () => {

  const [expenses, setExpenses] = useState({ status: false });

  const saveExpenses = async (file) => {

    // If data is already loading, wait for it
    if (fetchPromise) return fetchPromise;

    const formData = new FormData();
    formData.append("File", file); // name must match your API parameter


    // Start fetching
    fetchPromise = axios
      .post(`${local_backend}SAPIntegration/ImportCSVForSAPPluto`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            accept: "*/*",
          },
          withCredentials: false, // same as credentials: "omit"
        })
      .then((response) => {
        const items = Array.isArray(response?.data)
          ? response.data
          : response?.data
            ? [response.data]
            : [];

        const pickMessage = (item) =>
          item?.Message || item?.message || item?.statusMessage;

        const failed = items.find(
          (item) => item?.isSuccess === false || item?.IsSuccess === false
        );

        if (failed) {
          const message =
            pickMessage(failed) || "File upload failed.";
          setExpenses({ status: false, message });
          return { status: false, message };
        }

        const message =
          pickMessage(items[0]) || "File uploaded and processed successfully.";
        setExpenses({ status: true, message });
        return { status: true, message };
      })
      .catch((err) => {
        console.error("error:", err);
        const message =
          err?.response?.data?.Message ||
          err?.response?.data?.message ||
          err?.message;
        setExpenses({ status: false, message });
        return { status: false, message };
      })
      .finally(() => {
        fetchPromise = null;
      });

    return fetchPromise;
  };

  const refreshSuppliers = async () => {
    try {
      const response = await axios.post(
        `${local_backend}SAPIntegration/SAPQuerySupplier`,
        {
          lowerBoundaryIdentifier: "*",
          queryHitsMaximumNumberValue: 2000,
        },
        {
          headers: {
            accept: "*/*",
          },
          withCredentials: false,
        }
      );

      const isSuccess = response?.data === true;
      if (isSuccess) {
        return { status: true, message: "Suppliers refreshed successfully." };
      }

      return { status: false, message: "Failed to refresh suppliers." };
    } catch (err) {
      console.error("error:", err);
      return { status: false, message: "Failed to refresh suppliers." };
    }
  };

  return { saveExpenses, refreshSuppliers, expenses };
};

export default useExpenses;
